import * as examplesSagas from '../features/examples/redux/sagas';
import * as homeSagas from '../features/home/redux/sagas';
import * as masterPageSagas from '../features/master-page/redux/sagas';
import * as componentesSagas from '../features/componentes/redux/sagas';
import * as acessoSistemaSagas from '../features/acesso-sistema/redux/sagas';
import * as pessoasSagas from '../features/pessoas/redux/sagas';
import * as storageSagas from '../features/storage/redux/sagas';
import * as parametrosSistemaSagas from '../features/parametros-sistema/redux/sagas';
import * as pagesSagas from '../features/pages/redux/sagas';
import * as usuariosSagas from '../features/usuarios/redux/sagas';
import * as usuarioPerfilSagas from '../features/usuario-perfil/redux/sagas';
import * as commonSagas from '../features/common/redux/sagas';
import * as loginSapSagas from '../features/login-sap/redux/sagas';
import * as logsSistemaSagas from '../features/logs-sistema/redux/sagas';
// This file is auto maintained by rekit-plugin-redux-saga,
// you usually don't need to manually edit it.

// NOTE: DO NOT chanage featureSagas declearation pattern, it's used by rekit-plugin-redux-saga.
const featureSagas = [
  examplesSagas,
  homeSagas,
  masterPageSagas,
  componentesSagas,
  acessoSistemaSagas,
  pessoasSagas,
  storageSagas,
  parametrosSistemaSagas,
  pagesSagas,
  usuariosSagas,
  usuarioPerfilSagas,
  commonSagas,
  loginSapSagas,
  logsSistemaSagas,
];

const sagas = featureSagas.reduce((prev, curr) => [
  ...prev,
  ...Object.keys(curr).map(k => curr[k]),
], [])
// a saga should be function, below filter avoids error if redux/sagas.js is empty;
.filter(s => typeof s === 'function');

function* rootSaga() {
  yield sagas.map(saga => saga());
}

export default rootSaga;



// WEBPACK FOOTER //
// ./src/common/rootSaga.js